"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuTxt = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ScrollArea = tslib_1.__importStar(require("@jsonjoy.com/ui/lib/4-card/ScrollArea"));
const react_1 = require("react");
const nanoTheme = tslib_1.__importStar(require("nano-theme"));
const nano_theme_1 = require("nano-theme");
const slate_1 = require("slate");
const slate_react_1 = require("slate-react");
const slate_history_1 = require("slate-history");
const Paper_1 = require("@jsonjoy.com/ui/lib/4-card/Paper");
const useIsomorphicLayoutEffect_1 = tslib_1.__importDefault(require("react-use/lib/useIsomorphicLayoutEffect"));
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const collaborative_slate_1 = require("@jsonjoy.com/collaborative-slate");
const behavior_1 = require("./behavior");
const embed_1 = require("./behavior/embed");
const math_1 = require("./behavior/math");
const hr_1 = require("./behavior/hr");
const linkPaste_1 = require("./behavior/linkPaste");
const title_1 = require("./behavior/title");
const selectAllGuard_1 = require("./behavior/selectAllGuard");
const file_1 = require("./behavior/file");
const toc_1 = require("./behavior/toc");
const slate_2 = require("../translit/bindings/slate");
const MuTxtTranslit_1 = require("./translit/MuTxtTranslit");
const BlockElement_1 = require("./components/blocks/BlockElement");
const MuTxtFooter_1 = require("./chrome/footer/MuTxtFooter");
const ScrollMap_1 = require("./chrome/scroll/ScrollMap");
const Leaf_1 = require("./inline/components/Leaf");
const Placeholder_1 = require("./inline/components/Placeholder");
const MuTxtHeader_1 = require("./chrome/header/MuTxtHeader");
const InlineFloater_1 = require("./inline/InlineFloater");
const LinkFloater_1 = require("./inline/link/LinkFloater");
const InlineMathFloater_1 = require("./inline/InlineMathFloater");
const BlockFloater_1 = require("./block/BlockFloater");
const EmbedFloater_1 = require("./void/embed/EmbedFloater");
const FileFloater_1 = require("./void/file/FileFloater");
const OmniFloater_1 = require("./omni/OmniFloater");
const SelectAllGuardFloater_1 = require("./guard/SelectAllGuardFloater");
const IndicatorFloater_1 = require("./state/IndicatorFloater");
const context_2 = require("./context");
const context_3 = require("@jsonjoy.com/ui/lib/utils/portal/context");
const context_4 = require("@jsonjoy.com/ui/lib/context");
const ScopedResetContext_1 = require("@jsonjoy.com/ui/lib/context/ScopedResetContext");
const context_5 = require("@jsonjoy.com/ui/lib/7-fullscreen/ToastCardManager/context");
const ToastCardManager_1 = require("@jsonjoy.com/ui/lib/7-fullscreen/ToastCardManager");
const context_6 = require("@jsonjoy.com/ui/lib/styles/context");
const MuTxtState_1 = require("./state/MuTxtState");
const active_selection_1 = require("./behavior/active-selection");
const font_1 = require("./behavior/font");
const Sizer_1 = require("@jsonjoy.com/ui/lib/5-block/Sizer");
const json_crdt_1 = require("json-joy/lib/json-crdt");
const json_crdt_extensions_1 = require("json-joy/lib/json-crdt-extensions");
require("./loadFonts");
const KeyboardShortcutsModal = React.lazy(() => Promise.resolve().then(() => tslib_1.__importStar(require('./chrome/KeyboardShortcuts'))).then((m) => ({ default: m.KeyboardShortcutsModal })));
const EmbedDocsModal = React.lazy(() => Promise.resolve().then(() => tslib_1.__importStar(require('./chrome/EmbedDocs'))).then((m) => ({ default: m.EmbedDocsModal })));
const TranslitMapModal = React.lazy(() => Promise.resolve().then(() => tslib_1.__importStar(require('./translit/TranslitMapModal'))).then((m) => ({ default: m.TranslitMapModal })));
const computeEditableWidth = (shellWidth, kind) => {
    return kind === 'mid'
        ? Math.max(780, Math.min(900, Math.round(shellWidth * 0.6)))
        : kind === 'wide'
            ? Math.max(900, Math.min(1200, Math.round(shellWidth * 0.7)))
            : Math.max(640, Math.min(780, Math.round(shellWidth * 0.5)));
};
const renderElement = (props) => React.createElement(BlockElement_1.BlockElement, { ...props });
const shellClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    w: '100%',
    bxz: 'border-box',
    // maxW: '1200px',
    mr: '0 auto',
    ov: 'hidden',
});
const fitShellClass = (0, nano_theme_1.rule)({
    h: '100%',
    d: 'flex',
    fld: 'column',
});
// Host for MathLive's `<math-field>` virtual keyboard when in fullwindow /
// fullscreen mode.
const mathKbdHostClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    '& .MLK__backdrop': {
        pointerEvents: 'auto',
    },
});
const editableClass = (0, nano_theme_1.rule)({
    w: '100%',
    mr: '0 auto',
    pd: '22px 24px',
    bxz: 'border-box',
    fz: '16px',
    lh: 1.8,
    out: 'none',
});
const MuTxtInner = ({ state, editor, placeholder = Placeholder_1.DEF_PLACEHOLDER, presence, contentWidth, minHeight, maxHeight, height, heightFit, borderless, autoFocus, hoverElevate, readOnly, className = '', style, }) => {
    const styles = (0, context_1.useStyles)();
    const scopedResetClass = (0, ScopedResetContext_1.useScopedResetClass)();
    const peritextRef = state.peritextRef;
    // --------------------------------------------------------- Presence manager
    const { decorate: decorateRemoteCursors, sendLocalPresence } = (0, collaborative_slate_1.useSlatePresence)({
        manager: presence,
        peritext: peritextRef,
        editor,
        userFromMeta: (meta) => (meta ? { name: meta.name, color: meta.color } : undefined),
    });
    // biome-ignore lint/correctness/useExhaustiveDependencies: state instance is stable for the lifetime of the component
    (0, react_1.useEffect)(() => {
        state.publishPresence = sendLocalPresence;
    }, [sendLocalPresence]);
    // ----------------------------------------------------------- Toasts binding
    const toasts = (0, context_5.useToasts)();
    (0, react_1.useEffect)(() => {
        state.toasts = toasts;
        return () => {
            if (state.toasts === toasts)
                state.toasts = undefined;
        };
    }, [state, toasts]);
    // -------------------------------------------------------- Slate decorations
    const linkPopupOpen = state.inline.link.open.use();
    const activeSelectionRange = state.inline.link.rangeSnapshot.use();
    const omniOpen = state.omni.open.use();
    const omniRange = state.omni.rangeSnapshot.use();
    const shortcutsOpen = state.shortcutsOpen.use();
    const embedDocsOpen = state.embedDocsOpen.use();
    const translitMapOpen = state.translit.mapOpen.use();
    const displayMode = state.displayMode.use();
    const font = state.font.use();
    const editableWidthKind = state.editableWidth.use();
    const shellAvailableWidth = state.sizer.width.use();
    const shellDesiredWidth = state.sizer.content.use();
    const actualShellWidth = shellAvailableWidth > 0 ? Math.min(shellAvailableWidth, shellDesiredWidth) : shellDesiredWidth;
    const computedEditableWidth = actualShellWidth > 0 ? computeEditableWidth(actualShellWidth, editableWidthKind) : undefined;
    const [shellEl, setShellEl] = React.useState(null);
    const handleShellRef = React.useCallback((el) => {
        setShellEl(el);
        state.bindShell(el);
    }, [state]);
    const [mathKbdHostEl, setMathKbdHostEl] = React.useState(null);
    // MathLive's `<math-field>` virtual keyboard mounts into `document.body` by
    // default. In `fullwindow` and `fullscreen` we mount it inside the shell
    // instead, to ensure it appears above the editor content.
    (0, react_1.useEffect)(() => {
        const vk = globalThis.window?.mathVirtualKeyboard;
        if (!vk)
            return;
        const needsHost = displayMode === 'fullwindow' || displayMode === 'fullscreen';
        const next = needsHost && mathKbdHostEl ? mathKbdHostEl : document.body;
        // MathLive throws when
        try {
            vk.container = next;
        }
        catch { }
        return () => {
            try {
                vk.container = document.body;
            }
            catch { }
        };
    }, [displayMode, mathKbdHostEl]);
    const decorate = (0, react_1.useCallback)((entry) => {
        const ranges = [...decorateRemoteCursors(entry)];
        if (linkPopupOpen && activeSelectionRange) {
            const linkRange = (0, active_selection_1.decorActiveSelection)(entry, activeSelectionRange);
            if (linkRange)
                ranges.push(linkRange);
        }
        if (omniOpen && omniRange) {
            const omniDecor = (0, active_selection_1.decorActiveSelection)(entry, omniRange);
            if (omniDecor)
                ranges.push(omniDecor);
        }
        return ranges;
    }, [decorateRemoteCursors, linkPopupOpen, activeSelectionRange, omniOpen, omniRange]);
    // ---------------------------------------------------------------- Renderers
    const renderLeaf = (0, react_1.useMemo)(() => {
        const base = (props) => React.createElement(Leaf_1.Leaf, { ...props });
        return presence ? (0, collaborative_slate_1.withPresenceLeaf)(base) : base;
    }, [presence]);
    const editableStyle = {
        minHeight,
        maxWidth: contentWidth ?? computedEditableWidth ?? 800,
        color: styles.g(0.15),
        caretColor: styles.g(0),
        fontFamily: font_1.FONT_FAMILIES[font],
    };
    let content = (React.createElement(slate_react_1.Slate, { editor: editor, initialValue: editor.children, onChange: state.onChange, onSelectionChange: state.onSelection },
        React.createElement(slate_react_1.Editable, { ref: (el) => {
                state.editableBox.setEl(el ?? undefined);
                state.bindKbdSource(el);
                state.customStyle.setEditableEl(el ?? undefined);
            }, decorate: decorate, renderElement: renderElement, renderLeaf: renderLeaf, placeholder: placeholder, renderPlaceholder: (props) => React.createElement(Placeholder_1.Placeholder, { ...props }), spellCheck: true, autoFocus: autoFocus, readOnly: readOnly, className: editableClass, style: editableStyle, onFocus: () => state.setFocused(true), onBlur: () => state.setFocused(false) }),
        !shortcutsOpen && !embedDocsOpen && !translitMapOpen && React.createElement(InlineFloater_1.InlineFloater, null),
        !shortcutsOpen && !embedDocsOpen && !translitMapOpen && React.createElement(BlockFloater_1.BlockFloater, null),
        React.createElement(LinkFloater_1.LinkFloater, null),
        React.createElement(EmbedFloater_1.EmbedFloater, null),
        React.createElement(FileFloater_1.FileFloater, null),
        React.createElement(InlineMathFloater_1.InlineMathFloater, null),
        !shortcutsOpen && !embedDocsOpen && !translitMapOpen && React.createElement(OmniFloater_1.OmniFloater, null),
        !shortcutsOpen && !embedDocsOpen && !translitMapOpen && React.createElement(IndicatorFloater_1.IndicatorFloater, null)));
    let scrollAreaStyle;
    if (heightFit) {
        // NOTE: do NOT set `overflow: auto` here. The actual scrolling happens in
        // the inner `<ScrollArea.Viewport>`, which hides its native scrollbar via
        // `scrollbar-width: none` and `::-webkit-scrollbar { display: none }`.
        // Setting overflow on this outer wrapper would create a second native
        // scroll context with no scrollbar-hiding CSS — on macOS that surfaces as
        // the system overlay scrollbar flashing over the virtual one.
        scrollAreaStyle = { flex: '1 1 0%', minHeight: 0 };
    }
    else if (height || maxHeight) {
        scrollAreaStyle = { height, maxHeight };
    }
    if (scrollAreaStyle) {
        content = (React.createElement(ScrollArea.ScrollArea, { state: state.scroll, shadow: true, style: scrollAreaStyle },
            React.createElement(ScrollArea.Viewport, { onMouseDown: (e) => {
                    if (!e.currentTarget.contains(e.target))
                        return;
                    if (!state.api.focused() && !e.target.closest('[contenteditable]')) {
                        e.preventDefault();
                        state.api.focus();
                    }
                }, onMouseUp: (e) => {
                    if (!e.currentTarget.contains(e.target))
                        return;
                    if (!state.api.focused() && !e.target.closest('[contenteditable]')) {
                        e.preventDefault();
                        state.api.focus();
                    }
                } }, content),
            React.createElement(ScrollArea.ScrollRail, null,
                React.createElement(ScrollArea.Thumb, null),
                React.createElement(ScrollMap_1.ScrollMap, { editor: editor }))));
    }
    content = (React.createElement(React.Fragment, null,
        React.createElement(MuTxtHeader_1.MuTxtHeader, { editor: editor }),
        React.createElement("div", { ref: (el) => state.customStyle.setBodyEl(el ?? undefined), style: heightFit ? { flex: '1 1 0%', minHeight: 0, display: 'flex', flexDirection: 'column' } : undefined }, content),
        React.createElement(MuTxtFooter_1.MuTxtFooter, null),
        shortcutsOpen && (React.createElement(React.Suspense, { fallback: null },
            React.createElement(KeyboardShortcutsModal, null))),
        embedDocsOpen && (React.createElement(React.Suspense, { fallback: null },
            React.createElement(EmbedDocsModal, null))),
        !!translitMapOpen && (React.createElement(React.Suspense, { fallback: null },
            React.createElement(TranslitMapModal, null))),
        !shortcutsOpen && !embedDocsOpen && !translitMapOpen && React.createElement(SelectAllGuardFloater_1.SelectAllGuardFloater, null),
        React.createElement("div", { ref: setMathKbdHostEl, className: mathKbdHostClass, "aria-hidden": true }),
        (displayMode === 'fullwindow' || displayMode === 'fullscreen') && React.createElement(ToastCardManager_1.ToastCardManager, null)));
    const combinedClass = (scopedResetClass ? scopedResetClass + ' ' : '') +
        (className || '') +
        shellClass +
        (heightFit ? fitShellClass : '');
    const shellStyle = displayMode === 'fullwindow'
        ? {
            ...style,
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            maxWidth: 'none',
            borderRadius: 0,
            zIndex: 9999,
            background: String(styles.bg),
        }
        : style;
    if (borderless) {
        content = React.createElement('div', { ref: handleShellRef, style: shellStyle, className: combinedClass }, content);
    }
    else {
        content = React.createElement(Paper_1.Paper, {
            ref: handleShellRef,
            round: displayMode !== 'fullwindow',
            contrast: true,
            hover: true,
            hoverElevate,
            style: shellStyle,
            className: combinedClass,
        }, content);
    }
    return (React.createElement(context_2.SlateEditorContextProvider, { state: state },
        React.createElement(context_3.PortalParentProvider, { value: displayMode === 'fullscreen' ? shellEl : null },
            React.createElement(Sizer_1.Sizer, { state: state.sizer, minWidth: 300, handlePadding: 64, handleMaxHeight: 500, handleWidth: 3, style: heightFit ? { height: '100%', minHeight: 0 } : undefined }, content))));
};
const MuTxt = (props) => {
    const { obj, fromSlate, presence, autoFocus, readOnly, state: _state, onApi, startWithTitle, onTitleSubmit, theme: themeProp, } = props;
    // ---------------------------------------------- Parent UiProvider detection
    // Read parent context BEFORE wrapping in `EnsureUiProvider` so that
    // `parentServices` is null when no real parent provider is mounted above.
    const parentServices = (0, context_4.useUiServices)();
    const parentNano = nanoTheme.useTheme();
    const parentResolvedTheme = parentServices ? (parentNano.isLight ? 'light' : 'dark') : null;
    // ---------------------------------------------------- Title-submit callback
    const onTitleSubmitRef = React.useRef(onTitleSubmit);
    React.useEffect(() => {
        onTitleSubmitRef.current = onTitleSubmit;
    }, [onTitleSubmit]);
    // ------------------------------------------------------------- Editor state
    // biome-ignore lint/correctness/useExhaustiveDependencies: presence/readOnly/fromSlate are init-time only; do not recreate state on change
    const [editor, state] = (0, react_1.useMemo)(() => {
        const translit = new MuTxtTranslit_1.MuTxtTranslit();
        const editor = (0, title_1.withTitleSubmit)((0, slate_2.withTranslit)((0, toc_1.withToc)((0, hr_1.withHr)((0, file_1.withFile)((0, math_1.withMath)((0, embed_1.withEmbeds)((0, linkPaste_1.withLinkPaste)((0, behavior_1.withCodeBlockBreaks)((0, slate_history_1.withHistory)((0, slate_react_1.withReact)((0, slate_1.createEditor)()))))))))), translit, { shouldRun: (e) => !(0, behavior_1.isInRawTextBlock)(e) }), () => onTitleSubmitRef.current);
        const state = _state
            ? _state
            : new MuTxtState_1.MuTxtState(editor, obj ? obj : json_crdt_extensions_1.ModelWithExt.create(json_crdt_1.s.obj({ '@type': json_crdt_1.s.con('mutxt') })).api.obj([]), { collaborative: !!presence, readOnly, fromSlate, translit });
        const editorToReturn = _state ? _state.editor : editor;
        (0, selectAllGuard_1.withSelectAllGuard)(editorToReturn, {
            onDelete: () => state.selectAllGuard.requestDelete(),
            onReplaceWithText: (text) => state.selectAllGuard.requestReplaceWithText(text),
            onReplaceWithFragment: (fragment) => state.selectAllGuard.requestReplaceWithFragment(fragment),
        });
        return [editorToReturn, state];
    }, [obj, _state]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: autoFocus only applies on initial mount of the owned state
    (0, react_1.useEffect)(() => {
        if (_state)
            return; // We don't own the state.
        const stop = state.start();
        if (startWithTitle && state.api.isEmpty()) {
            // Convert the default empty paragraph into an empty title block. This
            // runs after `state.start()` so the operation flows through the active
            // PeritextBinding into the underlying CRDT (rather than being a stale
            // direct mutation of `editor.children`).
            slate_1.Transforms.setNodes(editor, { type: 'title' }, { at: [0] });
        }
        let focusTimer;
        if (autoFocus)
            focusTimer = setTimeout(() => state.api.focus(), 101);
        return () => {
            stop();
            clearTimeout(focusTimer);
        };
    }, [_state, state, startWithTitle, editor]);
    (0, useIsomorphicLayoutEffect_1.default)(() => {
        onApi?.(state.api);
    }, []);
    // ---------------------------------------------------- Props synchronization
    (0, react_1.useEffect)(() => {
        state.setReadOnly(!!readOnly);
    }, [state, readOnly]);
    // -------------------------------------------------------------------- Theme
    const themeOverride = state.theme.use();
    const systemDark = state.systemDark.use();
    let resolvedTheme;
    if (themeOverride === 'light' || themeOverride === 'dark')
        resolvedTheme = themeOverride;
    else if (themeOverride === 'auto')
        resolvedTheme = systemDark ? 'dark' : 'light';
    else if (themeProp === 'light' || themeProp === 'dark')
        resolvedTheme = themeProp;
    else if (parentResolvedTheme)
        resolvedTheme = parentResolvedTheme;
    else
        resolvedTheme = systemDark ? 'dark' : 'light';
    return (React.createElement(context_4.EnsureUiProvider, null,
        React.createElement(nanoTheme.Provider, { theme: resolvedTheme },
            React.createElement(context_6.Provider, { dark: resolvedTheme === 'dark' },
                React.createElement(MuTxtInner, { ...props, state: state, editor: editor })))));
};
exports.MuTxt = MuTxt;
